(() => {
  const rootSelector = '.sunruck-editorial';

  const assignHeadingId = (heading, sectionKey, index) => {
    const existingId = heading.id.trim();
    if (existingId && !/\s/.test(existingId) && document.getElementById(existingId) === heading) {
      return existingId;
    }

    const base = `sunruck-${sectionKey}-heading-${index + 1}`;
    let candidate = base;
    let suffix = 1;

    while (document.getElementById(candidate) && document.getElementById(candidate) !== heading) {
      candidate = `${base}-${suffix++}`;
    }

    heading.id = candidate;
    return candidate;
  };

  const createToc = (root, headings) => {
    const placeholder = root.querySelector('[data-sunruck-toc]');
    if (!placeholder) return;

    const labelText = root.dataset.tocLabel;
    if (headings.length < 2 || !labelText) {
      placeholder.replaceChildren();
      placeholder.hidden = true;
      return;
    }

    const sectionKey = (root.dataset.sectionId || root.id || 'article').replace(/[^a-zA-Z0-9_-]/g, '-');
    const details = document.createElement('details');
    details.className = 'sunruck-toc-details';

    const summary = document.createElement('summary');
    const summaryText = document.createElement('span');
    const title = document.createElement('span');
    title.className = 'sunruck-toc-title';
    title.textContent = labelText;
    summaryText.append(title);

    summary.append(summaryText);

    const navigation = document.createElement('nav');
    navigation.setAttribute('aria-label', labelText);

    const list = document.createElement('ul');
    list.className = 'sunruck-toc-list';

    headings.forEach((heading, index) => {
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'sunruck-toc-subheading';

      const link = document.createElement('a');
      link.href = `#${assignHeadingId(heading, sectionKey, index)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });

    navigation.append(list);
    details.append(summary, navigation);
    placeholder.replaceChildren(details);
    placeholder.hidden = false;
  };

  const initialize = (root) => {
    if (root.dataset.sunruckInitialized === 'true') return;
    const content = root.querySelector('.article-template__content');
    if (!content) return;

    const headings = Array.from(content.querySelectorAll('h1, h2, h3')).filter((heading) => {
      if (heading.textContent.trim()) return true;
      if (!heading.children.length) heading.hidden = true;
      return false;
    });
    const placeholder = root.querySelector('[data-sunruck-toc]');
    let lastIntroParagraph;
    for (const child of content.children) {
      if (child.tagName !== 'P') break;
      lastIntroParagraph = child;
    }
    if (placeholder) {
      if (lastIntroParagraph) lastIntroParagraph.after(placeholder);
      else content.prepend(placeholder);
    }
    createToc(root, headings);
    root.dataset.sunruckInitialized = 'true';
  };

  const initializeAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(rootSelector)) initialize(scope);
    scope.querySelectorAll(rootSelector).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target instanceof Element ? event.target : document);
  });
})();
